/**
 * Um CSV como o Excel em portugues o le.
 *
 * Ponto e virgula como separador e virgula decimal, porque e o que o Excel com
 * configuracao brasileira espera; o BOM na frente faz ele ler UTF-8 e nao embaralhar
 * os acentos dos cabecalhos. Era a montagem que a view de Adocao e Engajamento fazia,
 * movida para a apresentacao em 08/10/2026 - conteudo de exportacao e regra de
 * produto, e aqui ele e testado sem navegador.
 */
/** O numero com virgula decimal, ou vazio quando nao ha valor. */
export function csvDecimal(value, places = 1) {
    if (value === null || value === undefined || Number.isNaN(value)) {
        return '';
    }
    return value.toFixed(places).replace('.', ',');
}
/** As linhas, com o cabecalho, como TEXTO de CSV (sem o BOM). */
export function toCsv(header, rows) {
    const escape = (value) => {
        const text = String(value ?? '');
        return /[";\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
    };
    return [header, ...rows].map((row) => row.map(escape).join(';')).join('\r\n');
}
/** O arquivo CSV pronto: BOM + texto, com o tipo que o navegador reconhece. */
export function csvBlob(header, rows) {
    return new Blob([`﻿${toCsv(header, rows)}`], { type: 'text/csv;charset=utf-8;' });
}
//# sourceMappingURL=csv.js.map